import { SeasonFights } from '../../domain/models/seasonFights.model';
import { Action } from '../action.type';

export const RETRIEVE_SEASON_FIGHTS = 'RETRIEVE_SEASON_FIGHTS';
export const RETRIEVE_SEASON_FIGHTS_SUCCESS = 'RETRIEVE_SEASON_FIGHTS_SUCCESS';
export const RETRIEVE_SEASON_FIGHTS_FAILURE = 'RETRIEVE_SEASON_FIGHTS_FAILURE';

export type RetrieveSeasonFightsPayload = {
  seasonId: string;
  startDate: Date;
  endDate: Date;
  retry: number;
};

export interface RetrieveSeasonFightsSuccessPayload {
  seasonId: string;
  fights: SeasonFights[];
  lastUpdated: number;
}

export interface RetrieveSeasonFights
  extends Action<RetrieveSeasonFightsPayload> {
  type: typeof RETRIEVE_SEASON_FIGHTS;
  payload: RetrieveSeasonFightsPayload;
}

export interface RetrieveSeasonFightsSuccess
  extends Action<RetrieveSeasonFightsSuccessPayload> {
  type: typeof RETRIEVE_SEASON_FIGHTS_SUCCESS;
  payload: RetrieveSeasonFightsSuccessPayload;
}

export interface RetrieveSeasonFightsFailure extends Action<string> {
  type: typeof RETRIEVE_SEASON_FIGHTS_FAILURE;
  payload: string;
}
